import { Controller } from '@hotwired/stimulus'

export default class LemonwayIframeController extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String
  }

  connect() {
    this.initWidget()
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        isSidebarMenuEnabled: true,
        arePersonalFieldsReadonly: true, // Optional: blocks editing of first name and last name
        isWelcomePageEnabled: true, // Optional: controls whether welcome pages are displayed
        onMyAccount: () => this.redirectToNextStep(false, 4000),
        onFinish: () => this.redirectToNextStep(true, 1000),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    )
  }

  redirectToNextStep(success = false, delay = 0) {
    const url = new URL(this.redirectUrlValue)

    if (success) {
      url.searchParams.set("status", "success")
    }

    setTimeout(() => {
      window.location.replace(url)
    }, delay)
  }
}
